function printTemplate(title, list, LODOP) {
    // console.log(title, list)
    // 表格绘制
    let lineWidth = 1;
    let tableWidth = 735 // 表格宽度
    let tableLeft = 25; // 表格左外边距
    let fontSize = 11
    let contentFontSize = 10
    let marginTop = 15;

    // LODOP.SET_PRINT_PAGESIZE(2, 0, 0, 'A5')
    // LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1) // 打印旋转

    LODOP.SET_PRINT_PAGESIZE(1, '210mm', '140mm');

    LODOP.ADD_PRINT_TEXT(marginTop + 5, tableLeft, 700, 30, isEmptyStr(title.recordId));
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 1);
    setFontSizeAndColor(8, "#000000", LODOP)

    LODOP.ADD_PRINT_HTM(marginTop, tableLeft + 670, 700, 30, `<div style="border: 1px solid #000; width: 40px; height: 20px; text-align: center; line-height: 18px; font-size: 10px;">普通</div>`);

    LODOP.ADD_PRINT_TEXT(marginTop + 5, tableLeft + 640, 100, 30, "#/&");
    LODOP.SET_PRINT_STYLEA(0, "ItemType", 2);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
    setFontSizeAndColor(8, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 15, 0, 770, 30, isEmptyStr(title.company));
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    setFontSizeAndColor(18, "#000000", LODOP)
    // LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", 15);//字间距

    LODOP.ADD_PRINT_TEXT(marginTop + 45, 0, 770, 30, isEmptyStr(list.printTypeTitle));
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    setFontSizeAndColor(14, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 90, tableLeft, 700, 30, `姓名：${isEmptyStr(title.patientName)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 90, tableLeft + 180, 700, 30, `性别：${isEmptyStr(title.sex)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 90, tableLeft + 360, 700, 30, `出生日期：${isEmptyStr(title.birthday)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 90, tableLeft + 540, 700, 30, `就诊日期：${isEmptyStr(title.clinicalTime)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_LINE(marginTop + 108, tableLeft, marginTop + 108, tableLeft + tableWidth + 1, 0, lineWidth);// 第一条横线
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 120, tableLeft, 700, 30, `临床诊断：${isEmptyStr(title.diagnosisResultString)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_LINE(marginTop + 138, tableLeft, marginTop + 138, tableLeft + tableWidth + 1, 0, lineWidth);// 第二条横线
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 150, tableLeft, 700, 30, "RP");
    setFontSizeAndColor(fontSize, "#000000", LODOP)
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 1);

    LODOP.ADD_PRINT_TEXT(marginTop + 150, tableLeft, 700, 30, `剂数: ${isEmptyStr(list.totalDosage)}剂   用法：${isEmptyStr(list.usage)}   代煎：${isEmptyStr(list.isProcess) == 1 ? `是(￥${isEmptyStr(list.proxyFried)})` : '否'}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);

    // header
    if (list.type == 2) {
        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft, 700, 30, "品名");
        setFontSizeAndColor(fontSize, "#000000", LODOP)

        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft + 90, 700, 30, "剂量");
        setFontSizeAndColor(fontSize, "#000000", LODOP)

        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft + 140, 700, 30, "数量");
        setFontSizeAndColor(fontSize, "#000000", LODOP)

        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft + 190, 700, 30, "备注");
        setFontSizeAndColor(fontSize, "#000000", LODOP)

        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft + 250, 700, 30, "品名");
        setFontSizeAndColor(fontSize, "#000000", LODOP)

        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft + 330, 700, 30, "剂量");
        setFontSizeAndColor(fontSize, "#000000", LODOP)

        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft + 380, 700, 30, "数量");
        setFontSizeAndColor(fontSize, "#000000", LODOP)

        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft + 430, 700, 30, "备注");
        setFontSizeAndColor(fontSize, "#000000", LODOP)

        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft + 490, 700, 30, "品名");
        setFontSizeAndColor(fontSize, "#000000", LODOP)

        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft + 580, 700, 30, "剂量");
        setFontSizeAndColor(fontSize, "#000000", LODOP)

        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft + 630, 700, 30, "数量");
        setFontSizeAndColor(fontSize, "#000000", LODOP)

        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft + 680, 700, 30, "备注");
        setFontSizeAndColor(fontSize, "#000000", LODOP)
    } else {
        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft, 700, 30, "品名");
        setFontSizeAndColor(fontSize, "#000000", LODOP)

        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft + 150, 700, 30, "剂量");
        setFontSizeAndColor(fontSize, "#000000", LODOP)

        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft + 200, 700, 30, "数量");
        setFontSizeAndColor(fontSize, "#000000", LODOP)

        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft + 260, 700, 30, "备注");
        setFontSizeAndColor(fontSize, "#000000", LODOP)

        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft + 380, 700, 30, "品名");
        setFontSizeAndColor(fontSize, "#000000", LODOP)

        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft + 530, 700, 30, "剂量");
        setFontSizeAndColor(fontSize, "#000000", LODOP)

        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft + 580, 700, 30, "数量");
        setFontSizeAndColor(fontSize, "#000000", LODOP)

        LODOP.ADD_PRINT_TEXT(marginTop + 175, tableLeft + 640, 700, 30, "备注");
        setFontSizeAndColor(fontSize, "#000000", LODOP)
    }

    // content
    for (let i = 0; i < list.patientChineseDrugPiecesList.length; i++) {
        let item = list.patientChineseDrugPiecesList[i]
        let num = item.value * list.totalDosage

        if (list.type == 2) {
            if (i < 7) {
                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i + 1) * 25, tableLeft, 700, 90, isEmptyStr(item.drugName.replace('配方颗粒', '')));
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)

                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i + 1) * 25, tableLeft + 90, 50, 30, isEmptyStr(item.value));
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)

                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i + 1) * 25, tableLeft + 140, 50, 30, `${(isEmptyStr(num))} ${isEmptyStr(item.unit)}`);
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)

                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i + 1) * 25, tableLeft + 190, 50, 30, isEmptyStr(item.comment));
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)
            } else if (i > 13) {
                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i - 13) * 25, tableLeft + 490, 90, 30, isEmptyStr(item.drugName.replace('配方颗粒', '')));
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)

                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i - 13) * 25, tableLeft + 580, 50, 30, isEmptyStr(item.value));
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)

                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i - 13) * 25, tableLeft + 630, 50, 30, `${(isEmptyStr(num))} ${isEmptyStr(item.unit)}`);
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)

                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i - 13) * 25, tableLeft + 680, 50, 30, isEmptyStr(item.comment));
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)
            } else {
                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i - 6) * 25, tableLeft + 250, 90, 30, isEmptyStr(item.drugName.replace('配方颗粒', '')));
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)

                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i - 6) * 25, tableLeft + 330, 50, 30, isEmptyStr(item.value));
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)

                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i - 6) * 25, tableLeft + 380, 50, 30, `${(isEmptyStr(num))} ${isEmptyStr(item.unit)}`);
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)

                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i - 6) * 25, tableLeft + 430, 50, 30, isEmptyStr(item.comment));
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)
            }
        } else {
            if (i < 7) {
                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i + 1) * 25, tableLeft, 700, 150, isEmptyStr(item.drugName.replace('配方颗粒', '')));
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)

                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i + 1) * 25, tableLeft + 150, 50, 30, isEmptyStr(item.value));
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)

                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i + 1) * 25, tableLeft + 200, 60, 30, `${(isEmptyStr(num))} ${isEmptyStr(item.unit)}`);
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)

                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i + 1) * 25, tableLeft + 260, 100, 30, isEmptyStr(item.comment));
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)
            } else {
                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i - 6) * 25, tableLeft + 380, 150, 30, isEmptyStr(item.drugName.replace('配方颗粒', '')));
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)

                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i - 6) * 25, tableLeft + 530, 50, 30, isEmptyStr(item.value));
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)

                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i - 6) * 25, tableLeft + 580, 60, 30, `${(isEmptyStr(num))} ${isEmptyStr(item.unit)}`);
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)

                LODOP.ADD_PRINT_TEXT(marginTop + 175 + (i - 6) * 25, tableLeft + 640, 100, 30, isEmptyStr(item.comment));
                setFontSizeAndColor(contentFontSize, "#000000", LODOP)
            }
        }
    }

    LODOP.ADD_PRINT_LINE(marginTop + 400, tableLeft, marginTop + 400, tableLeft + tableWidth + 1, 0, lineWidth);// 第三条横线

    LODOP.ADD_PRINT_TEXT(marginTop + 412, tableLeft, 700, 30, `医生: ${title.printDoctorName == 1 ? isEmptyStr(title.realName) : ''}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 412, tableLeft + 120, 700, 30, "审查：");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 412, tableLeft + 240, 700, 30, "调配：");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 412, tableLeft + 360, 700, 30, "核对：");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 412, tableLeft + 480, 700, 30, "发药：");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    // printTotalPrice == 1
    LODOP.ADD_PRINT_TEXT(marginTop + 412, tableLeft + 600, 700, 30, `金额：￥${title.printTotalPrice == 1 ? isEmptyStr(list.amount) : ''}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_LINE(marginTop + 430, tableLeft, marginTop + 430, tableLeft + tableWidth + 1, 0, lineWidth);// 第四条横线
}

function printTemplateA5(title, list, LODOP) {
    // console.log(title, list)
    // 表格绘制
    let lineWidth = 1;
    let tableWidth = 500 // 表格宽度
    let tableLeft = 15; // 表格左外边距
    let fontSize = 11
    let contentFontSize = 10
    let marginTop = 35;

    LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A5')
    // LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1) // 打印旋转

    // LODOP.SET_PRINT_PAGESIZE(1, '148mm', '210mm', '处方');

    LODOP.ADD_PRINT_TEXT(marginTop - 15, tableLeft, 540, 30, isEmptyStr(title.recordId) ? `NO.${title.recordId}` : '');
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 1);
    setFontSizeAndColor(8, "#000000", LODOP)

    LODOP.ADD_PRINT_HTM(marginTop - 20, tableLeft + 435, 540, 30, `<div style="border: 1px solid #000; width: 40px; height: 20px; text-align: center; line-height: 18px; font-size: 10px;">普通</div>`);

    LODOP.ADD_PRINT_TEXT(marginTop - 15, tableLeft + 400, 100, 30, "#/&");
    LODOP.SET_PRINT_STYLEA(0, "ItemType", 2);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);
    setFontSizeAndColor(8, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 15, 0, 540, 30, isEmptyStr(title.company));
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    setFontSizeAndColor(18, "#000000", LODOP)
    // LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", 15);//字间距

    LODOP.ADD_PRINT_TEXT(marginTop + 45, 0, 540, 30, isEmptyStr(list.printTypeTitle));
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
    setFontSizeAndColor(14, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 90, tableLeft, 540, 30, `姓名：${isEmptyStr(title.patientName)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 90, tableLeft + 180, 540, 30, `性别：${isEmptyStr(title.sex)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 90, tableLeft + 340, 540, 30, `年龄：${isEmptyStr(getAge(title.clinicalAge, title.year, title.month, title.day))}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_LINE(marginTop + 108, tableLeft, marginTop + 108, tableLeft + tableWidth + 1, 0, lineWidth);// 第一条横线
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 120, tableLeft, 700, 30, `手机号：${isEmptyStr(title.phoneNo)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 120, tableLeft + 180, 540, 30, `科室：${isEmptyStr(title.laboratoryName)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 120, tableLeft + 340, 540, 30, `就诊日期：${isEmptyStr(title.clinicalTime)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_LINE(marginTop + 138, tableLeft, marginTop + 138, tableLeft + tableWidth + 1, 0, lineWidth);// 第二条横线
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 150, tableLeft, 700, 30, `临床诊断：${isEmptyStr(title.diagnosisResultString)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_LINE(marginTop + 168, tableLeft, marginTop + 168, tableLeft + tableWidth + 1, 0, lineWidth);// 第三条横线
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 180, tableLeft, 700, 30, `过敏史：${isEmptyStr(title.allergyHistory)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_LINE(marginTop + 198, tableLeft, marginTop + 198, tableLeft + tableWidth + 1, 0, lineWidth);// 第四条横线
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 210, tableLeft, 700, 30, "R");
    setFontSizeAndColor(fontSize + 5, "#000000", LODOP)
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);

    LODOP.ADD_PRINT_TEXT(marginTop + 216, tableLeft + 14, 700, 30, "P");
    setFontSizeAndColor(fontSize, "#000000", LODOP)
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);

    LODOP.ADD_PRINT_TEXT(marginTop + 240, tableLeft, 700, 30, "品名");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 240, tableLeft + 125, 700, 30, "剂量");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 240, tableLeft + 160, 700, 30, "数量");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 240, tableLeft + 210, 700, 30, "备注");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 240, tableLeft + 260, 700, 30, "品名");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 240, tableLeft + 385, 700, 30, "剂量");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 240, tableLeft + 420, 700, 30, "数量");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 240, tableLeft + 470, 700, 30, "备注");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    // content
    for (let i = 0; i < list.patientChineseDrugPiecesList.length; i++) {
        let item = list.patientChineseDrugPiecesList[i]
        let num = item.value * list.totalDosage

        if (i < 12) {
            LODOP.ADD_PRINT_TEXT(marginTop + 240 + (i + 1) * 25, tableLeft, 700, 150, isEmptyStr(item.drugName.replace('配方颗粒', '')));
            setFontSizeAndColor(contentFontSize, "#000000", LODOP)

            LODOP.ADD_PRINT_TEXT(marginTop + 240 + (i + 1) * 25, tableLeft + 125, 50, 30, isEmptyStr(item.value));
            setFontSizeAndColor(contentFontSize, "#000000", LODOP)

            LODOP.ADD_PRINT_TEXT(marginTop + 240 + (i + 1) * 25, tableLeft + 160, 60, 30, `${(isEmptyStr(num))} ${isEmptyStr(item.unit)}`);
            setFontSizeAndColor(contentFontSize, "#000000", LODOP)

            LODOP.ADD_PRINT_TEXT(marginTop + 240 + (i + 1) * 25, tableLeft + 210, 100, 30, isEmptyStr(item.comment));
            setFontSizeAndColor(contentFontSize, "#000000", LODOP)
        } else {
            LODOP.ADD_PRINT_TEXT(marginTop + 240 + (i - 11) * 25, tableLeft + 260, 150, 30, isEmptyStr(item.drugName.replace('配方颗粒', '')));
            setFontSizeAndColor(contentFontSize, "#000000", LODOP)

            LODOP.ADD_PRINT_TEXT(marginTop + 240 + (i - 11) * 25, tableLeft + 385, 50, 30, isEmptyStr(item.value));
            setFontSizeAndColor(contentFontSize, "#000000", LODOP)

            LODOP.ADD_PRINT_TEXT(marginTop + 240 + (i - 11) * 25, tableLeft + 420, 60, 30, `${(isEmptyStr(num))} ${isEmptyStr(item.unit)}`);
            setFontSizeAndColor(contentFontSize, "#000000", LODOP)

            LODOP.ADD_PRINT_TEXT(marginTop + 240 + (i - 11) * 25, tableLeft + 470, 100, 30, isEmptyStr(item.comment));
            setFontSizeAndColor(contentFontSize, "#000000", LODOP)
        }
    }

    LODOP.ADD_PRINT_TEXT(marginTop + 570, tableLeft, 700, 30, `医生: ${title.printDoctorName == 1 ? isEmptyStr(title.realName) : ''}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 570, tableLeft, tableWidth, 30, `金额：￥${title.printTotalPrice == 1 ? isEmptyStr(list.amount) : ''}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);

    LODOP.ADD_PRINT_LINE(marginTop + 588, tableLeft, marginTop + 588, tableLeft + tableWidth + 1, 0, lineWidth);// 第五条横线
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 600, tableLeft, 700, 30, "审查：");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 600, tableLeft + 120, 700, 30, "调配：");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 600, tableLeft + 240, 700, 30, "核对：");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 600, tableLeft + 360, 700, 30, "发药：");
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_LINE(marginTop + 618, tableLeft, marginTop + 618, tableLeft + tableWidth + 1, 0, lineWidth);// 第六条横线
    LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);

    LODOP.ADD_PRINT_TEXT(marginTop + 630, tableLeft, 700, 30, `注：${isEmptyStr(title.remark)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 650, tableLeft, 700, 30, `用法：${isEmptyStr(list.usage)}, ${isEmptyStr(list.frequency)}, 共${isEmptyStr(list.totalDosage)}剂`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)

    LODOP.ADD_PRINT_TEXT(marginTop + 670, tableLeft, 700, 30, `备注：${isEmptyStr(title.dailyDosage)}`);
    setFontSizeAndColor(fontSize, "#000000", LODOP)
}

const isEmptyStr = (value) => {
    if (value == null || value == undefined || value == '') {
        return ''
    }
    return value
}

const setFontSizeAndColor = (fontSize, color, LODOP) => {
    LODOP.SET_PRINT_STYLEA(0, "FontSize", fontSize);
    LODOP.SET_PRINT_STYLEA(0, "FontColor", color);
}

const getAge = (clinicalAge, year, month, day) => {
    if (clinicalAge) {
        return clinicalAge
    } else {
        let str = ''
        if (year > 0) {
            str += `${year}岁`
        }
        if (month > 0 && year >= 0 && year < 5) {
            str += `${month}月`
        }
        if (year === 0 && day > 0) {
            str += `${day}天`
        }
        return str
    }
}

export { printTemplate, printTemplateA5 }